import configJson from './auth_config.json';
interface Iconfig {
  audience?: any;
  domain: string;
  clientId: string;
  redirect?: any;
  hotjarSiteId: number;
  hotjarVersion: number;
}

export const getConfig: () => Iconfig = () => {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER" (which
  // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
  // don't have an API).
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience =
    configJson.audience && configJson.audience !== 'YOUR_API_IDENTIFIER'
      ? configJson.audience
      : null;

  return {
    domain: `${process.env.REACT_APP_AUTH_DOMAIN}`,
    clientId: `${process.env.REACT_APP_AUTH_CLIENT_ID}`,
    hotjarSiteId: parseInt(process.env.REACT_APP_HOTJAR_SITE_ID ?? '0', 10),
    hotjarVersion: parseInt(process.env.REACT_APP_HOTJAR_VERSION ?? '0', 10),
    ...(audience ? {audience} : null)
  };
};

export const API_ENDPOINT_JSON = {
  sendSignUpOTP: '/user/sendSignUpOTP',
  resendSignUpOTP: '/user/resendSignUpOTP',
  verifyAccount: '/user/verifyAccount',
  verifyEmailAndSendOTP: '/user/verifyEmailAndSendOTP',
  resendForgotPasswordOTP: '/user/resendForgotPasswordOTP',
  verifyForgotPasswordOTP: '/user/verifyForgotPasswordOTP',
  verifyAndChangePassword: '/user/verifyAndChangePassword',
  askAI: '/ai/askai',
  me: '/user/me',
  user: '/user',
  userSetup: '/user/setup',
  isUserDuplicate: '/user/isUserDuplicate',
  companyUser: '/user/company',
  role: '/userRole',
  userPermission: 'userPermission',
  companyDetails: '/company',
  sustainabilityResponses: '/sustainabilityResponses',
  activeFacilityCount: '/facility/activeFacilityCount',
  razorCreatePayment: '/payment/createPayment',
  razorVerifyPayment: '/payment/payment-verify',
  subscriptionDetails: '/subscriptions',
  pricingDetails: '/subscriptions/pricingDetails',
  businessDetails: '/businessdetails',
  facilityDetails: '/facility',
  facilityDetailsDropdown: '/facility/dropdown',
  facilityCompany: '/facility/company',
  facility_headquarters: '/facility/headquarters',
  uploadFile: '/company/upload',
  uploadUserManagerFile: '/general/uMUpload',
  uploadDocsFile: '/documentdata',
  jobs: '/company/job',
  ownerShip: '/ownership',
  holding: '/holding',
  holding_valueChain: '/holding/valueChain',
  holding_dataCollection: '/holding/dataCollection',
  machine: '/fuelconsumption/machine',
  machineUploadAttachedDocument:
    '/fuelconsumption/machine/uploadAttachedDocument',
  vehicle: '/fuelconsumption/vehicle',
  vehicleUploadAttachedDocument:
    '/fuelconsumption/vehicle/uploadAttachedDocument',
  fugitive: '/fuelconsumption/refrigerant',
  electricity: '/electricity',
  electricityRenewableUploadAttachedDocument:
    '/electricity/renewable/uploadAttachedDocument',
  electricityNonRenewableUploadAttachedDocument:
    '/electricity/nonRenewable/uploadAttachedDocument',
  supplyChain: '/supplychain',
  water: '/water',
  prefUnits: '/prefferedunits',
  capitalGoods: '/capitalgoods',
  employee: '/employeecommute',
  businessTravel: '/businesstravel',
  businessTravelUploadAttachedDocument:
    '/businesstravel/uploadAttachedDocument',
  otherActivities: '/otheractivities',
  downstreamLeasedAsset: '/downstreamleasedasset',
  downstreamLeasedAsset_valueChain: '/downstreamleasedasset/valueChain',
  downstreamLeasedAsset_dataCollection: '/downstreamleasedasset/dataCollection',
  supplierInfo: '/supplier',
  efdb: '/emissionfactordatabase/all',
  efdbCRUD: '/emissionfactordatabase',
  waste: '/waste',
  productInfo: '/product',
  copilotChat: '/ai/copilotChat',
  pcf: '/pcf',
  rawMaterial: '/product/rawMaterial',
  B2B: '/product/processingProducts',
  B2C: {
    dce: '/product/consumeEnergy',
    faf: '/product/feedstocks',
    gh: '/product/greenHouse'
  },
  REPORT_BUILDER: {
    saveReportDetails: '/reportbuilder/saveReportDetails',
    getReportDetails: '/reportbuilder/getReport',
    getFrameworkPillars: '/reportbuilder/getFrameworkPillars',
    getReports: '/reportbuilder/getReports',
    deleteReport: '/reportbuilder/deleteReport',
    updateFavorite: '/reportbuilder/updateFavorite',
    updateReportName: '/reportbuilder/updateReportName'
  },
  EndOfLife: '/product/endTreatment',
  upstreamLeasedAsset: '/upstreamLeasedAsset',
  franchise: '/franchise',
  franchise_valueChain: '/franchise/valueChain',
  franchise_dataCollection: '/franchise/dataCollection',
  equity: '/equityinvestment',
  debt: '/debtinvestment',
  projectFinance: '/projectfinance',
  OCR: '/documentdata',
  AIDocumentManager: '/documentdata/documentRecord',
  AIDocumentUpdateReferenceRecordId: '/documentdata/updateReferenceRecordId',
  AIDocumentOCRStatusPolling: '/documentdata/documentpolling/status',
  getPermissions: '/userPermission/auth0/web',
  editUser: '/user/update/assign-roles-permissions',
  assigneRolePermissions: '/user/assign-roles-permissions',
  assignPermissionExternal: '/user/assign-roles-permissions-external',
  getAllUsers: '/user/role/permission',
  reportBuilderUsers: '/user/reportBuilderUsers',
  getTotalUserCount: '/user/getTotalUserCount',
  getEmployees: '/employeecommute/UM/company',
  stakeHolderTracking: '/stakeholdertracking',
  dataLineage: '/dataLineage',
  JSON: {
    category: '/dropdown/categories',
    unitPreference: '/unitpreference',
    subCategory: '/dropdown/subCategories',
    designation: '/dropdown/designation',
    gender: '/dropdown/gender',
    typeofbusiness: '/dropdown/typeOfBusiness',
    country: '/dropdown/country',
    state: '/dropdown/states',
    city: '/dropdown/cities',
    holding: '/dropdown/holdingType',
    facilityType: '/dropdown/facilitySpace',
    deviceType: '/dropdown/stationaryCombustion',
    deviceFuel: '/dropdown/deviceFuelUsed',
    vehicleFuelUsed: '/dropdown/vehicleFuelUsed',
    vehicleType: '/dropdown/vehicleType',
    fugitiveType: '/dropdown/refrigerantSuppressantUsed',
    emissionSource: '/dropdown/fugitiveEmissionSources',
    frequency: '/dropdown/frequency',
    electricityBoard: '/dropdown/electricityBoard',
    renewableType: '/dropdown/ElectricityRenewableType',
    partnerType: '/dropdown/partnerType',
    modeOfTransportBySupply: '/dropdown/modeOfTransportBySupplyChain',
    modeOfTransportByTravel: '/dropdown/modeOfTransportByTravel',
    classOfTravel: '/dropdown/classOfTravel',
    capitalGoods: '/dropdown/capitalGoods',
    processType: '/dropdown/processType',
    propertyType: '/dropdown/propertyType',
    waterSource: '/dropdown/waterSource',
    workingDaysInWeek: '/dropdown/workingDaysInWeek',
    wasteCategory: '/dropdown/wastecategory',
    wasteType: '/dropdown/wasteType',
    products: '/dropdown/products',
    rawMaterials: '/dropdown/rawMaterials',
    rating: '/dropdown/rating',
    resType: '/dropdown/restaurantType',
    supplierType: '/dropdown/supplierType',
    efdb: '/dropdown/efdb',
    roleType: '/userRole/auth0/role',
    accessType: '/userRole/auth0/access',
    activityType: '/dropdown/activitytypes',
    efdbDropDown: '/emissionfactordatabase/dropdown'
  },
  ESG: {
    pillars: {
      GRI: '/gri/pillars',
      BRSR: '/brsreport/pillars',
      TCFD: '/tcfd/pillars',
      CDP: '/cdp/pillars',
      CDP_CORPORATE: '/cdpcorporate/pillars',
      CBAM: '/cbam/pillars',
      CBAM_IRON_AND_STEEL: '/cbam/ironandsteel/pillars',
      SASB: '/sasb/pillars'
    },
    GRI: {
      general: '/gri/general',
      governance: '/gri/governance',
      environmental: '/gri/environmental',
      social: '/gri/social'
    },
    BRSR: {
      generalDisclosure: '/brsreport/generaldisclosure',
      mapDisclosure: '/brsreport/mapdisclosure',
      pwpDisclocure: '/brsreport/pwpdisclosure'
    },
    SASB: {
      realEstate: '/sasb/realEstate'
    },
    TCFD: {
      tcfd: '/tcfd'
    },
    CDP: {
      cdp: '/cdp'
    },
    CDP_CORPORATE: {
      cdpcorporate: '/cdpcorporate',
      documentUpload: {
        climateChange: '/cdpcorporate/uploadFile/climateChange',
        businessStrategy: '/cdpcorporate/uploadFile/businessStrategy',
        governance: '/cdpcorporate/uploadFile/governance',
        management: '/cdpcorporate/uploadFile/management'
      }
    },
    CBAM: {
      section1ExporterAndInstallationProfile:
        '/cbam/section1Exporter&InstallationProfile',
      section2ActivityDataAndProductionSystemBoundary:
        '/cbam/section2ActivityData&ProductionSystemBoundary',
      section3DirectEmbeddedEmissionsScope1:
        '/cbam/section3DirectEmbeddedEmissionsScope1',
      section4IndirectEmbeddedEmissionsElectricity:
        '/cbam/section4IndirectEmbeddedEmissionsElectricity',
      section5PrecursorEmissions: '/cbam/section5PrecursorEmissions',
      section6MethodologyDataQualityVerification:
        '/cbam/section6Methodology&DataQuality&Verification',
      section7EmissionSummaryAndExportSpecificOutput:
        '/cbam/section7EmissionSummary&ExportSpecificOutput'
    },

    CBAM_IRON_AND_STEEL: {
      section1IronAndSteelPlantAndProductionInformation:
        '/cbam/section1Plant&ProductionInformation',
      section2IronAndSteelSourceStreamAndDirectEmissionsData:
        '/cbam/section2SourceStream&DirectEmissionsData',
      section3IronAndSteelElectricityAndIndirectEmissions:
        '/cbam/section3Electricity&IndirectEmissions',
      section4IronAndSteelProcessLevelProductionAndEmissionsData:
        '/cbam/section4ProcessLevelProduction&EmissionsData',
      section5IronAndSteelPrecursorPurchasedInputEmissionsData:
        '/cbam/section5PrecursorPurchasedInputEmissionsData',
      section6IronAndSteelCarbonPricingAndTaxAdjustment:
        '/cbam/section6CarbonPricing&TaxAdjustment',
      section7IronAndSteelShipmentAndCustomsInformation:
        '/cbam/section7Shipment&CustomsInformation'
    },
    CBAM_IRON_AND_STEEL_: {ironAndSteel: '/cbam/ironandsteel'},
    downloadReport: {
      brsrReport: '/brsreport/generate',
      caReport: '/brsreport/ca/report',
      tcfdReport: '/tcfd/report/download',
      griReport: '/brsreport/gri/report',
      cdpReport: '/cdp/report',
      cdpCorporateReport: '/cdpcorporate/report'
    },
    preFill: {
      brsrDataPrefill: '/brsreport/mapping'
    },
    replicateFramework: {
      replicateFrameworkMappingData: '/brsreport/replicatedata'
    }
  },
  NZM: {
    generalize: '/nzm/generalized',
    supplyChain: '/nzm/supplyChain',
    travel: '/nzm/travel',
    asset: '/nzm/assets',
    product: '/nzm/product',
    utility: {
      fuel: '/nzm/fuel',
      electricity: '/nzm/electricity',
      water: '/nzm/water',
      waste: '/nzm/waste'
    }
  },
  CONFIGURATOR: {
    orgHierarchyChart: '/orghierarchy',
    processFlow: '/processflow'
  },
  DASHBOARD: {
    activityPerformance: '/dashboard/activityPerformance',
    listOfActivity: '/dashboard/listOfActivity',
    emissionCalculation: '/emissioncalculations',
    getEmissionByPeriod: '/netzerotarget/get-graph-record',
    reductionTimeline: '/netzerotarget/emission-reduction-timeline',
    emissionsScopeWise: '/nzm/strategy/SDG/scopeWise',
    intensityWise: '/nzm/strategy/SDG/intensity',
    consumptionWise: '/nzm/strategy/SDG/consumption'
  },
  imageBucketURL: 'http://bharat-carbon-v2-assets.s3.amazonaws.com',
  s3_bucket:
    'https://bharatcarbon-nifi.s3.ap-south-1.amazonaws.com/excelSampleProd',
  activityLog: '/activitylog/getActivity',
  activityLogUsers: '/activitylog/activityloguser',
  reportStudio: '/reportstudio/getReports',
  reportBuilder: '/reportbuilder/documentdata'
};

export const nzmURL = {
  generalized: `https://app.powerbi.com/view?r=eyJrIjoiMTUzYWNlZTktNzFhNC00MDUwLWJhYmUtNTg5Yz
  lmOGFlMzI4IiwidCI6IjgyMTMxMzk0LTA5NjctNGRlOS05NzE3LWU1YTQ3NDQyY2U3NCIsImMiOjEwfQ%3D%3D`,
  utility: `https://app.powerbi.com/view?r=eyJrI
  joiNDM3YmNiNzgtMDZjYi00NzUzLTkzNjMtODYyODIyNjllNjMxIiw
  idCI6IjgyMTMxMzk0LTA5NjctNGRlOS05NzE3LWU1YTQ3NDQyY2U3NCIsImMiOjEwfQ%3D%3D`,
  supplyChain: '',
  travel: '',
  capitalGoods: '',
  asset: '',
  otherActivity: '',
  products: ''
};

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const STRATEGY_BASE_URL = process.env.REACT_APP_STRATEGY_BASE_URL;
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
